tasks-delivered-count
  span { opts.value }
  script(type="typescript").
    this.mixin('tasks.delivered-count');
